/* Same-variant packs: no discount codes, cart writes, or payment overrides. */
(()=>{'use strict';
function quote(variant,quantity,tiers,rule={}){
 const q=Math.max(1,Math.round(Number(quantity)||1)),unit=Math.max(0,Number(variant?.price)||0);
 const percent=tiers.reduce((best,t)=>q>=Number(t.quantity)?Math.max(best,Math.min(100,Math.max(0,Number(t.percent)||0))):best,0);
 const base=unit*q,discount=Math.floor((base*percent+1e-7)/100),total=base-discount;
 const original=Math.max(unit,Number(variant?.compare_at_price)||0)*q;
 const max=Math.min(20,rule.max??Infinity,rule.stock??Infinity),min=Math.max(1,rule.min||1),step=Math.max(1,rule.increment||1);
 return {quantity:q,total,original,saving:original-total,percent:original?Math.round((original-total)*100/original):0,each:total/q,offerPercent:percent,available:!!variant?.available&&q>=min&&q<=max&&(q-min)%step===0,max,min,step};
}
// Pure calculation exported for regression checks; browser uses the same function.
if(typeof module!=='undefined'&&module.exports)module.exports={quote};
if(typeof window==='undefined')return;
if(customElements.get('oblivion-bundle'))return;
class OblivionBundle extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;
  const source=this.querySelector('[data-bundle-config]');if(!source)return;
  try{this.config=JSON.parse(source.textContent);}catch{return;}
  this.form=document.getElementById('ProductForm');this.quantity=this.form?.elements.quantity;
  if(!this.quantity)return;
  this.ready=true;this.cards=[...this.querySelectorAll('.ob-bundle__card')];
  this.money=n=>new Intl.NumberFormat(document.documentElement.lang||'en-IN',{style:'currency',currency:this.config.currency||'INR',minimumFractionDigits:2}).format(n/100);
  this.addEventListener('change',event=>{if(event.target.name!=='ob_bundle_pack')return;this.quantity.value=event.target.value;this.quantity.dispatchEvent(new Event('change',{bubbles:true}));});
  this.quantity.dispatchEvent(new Event('change',{bubbles:true}));
 }
 quote(variant,quantity){
  if(!this.ready)return null;
  // These native automatic discounts apply to one-time purchases only.
  if(this.form.elements.selling_plan?.value){this.removeAttribute('data-loading');this.hidden=true;return null;}
  return quote(variant,quantity,this.config.tiers,this.config.variants[String(variant?.id)]);
 }
 render(variant,quantity){
  if(!this.ready||this.form.elements.selling_plan?.value)return;
  this.removeAttribute('data-loading');this.hidden=false;
  for(const card of this.cards){
   const input=card.querySelector('input'),p=this.quote(variant,Number(input.value));
   input.checked=p.quantity===quantity;input.disabled=!p.available;
   card.classList.toggle('is-unavailable',!p.available);
   card.querySelector('[data-bundle-total]').textContent=this.money(p.total);
   const was=card.querySelector('[data-bundle-original]');was.textContent=this.money(p.original);was.hidden=p.original<=p.total;
   const off=card.querySelector('[data-bundle-discount]');off.textContent=p.percent+'% '+this.config.offLabel;off.hidden=!p.percent;
   const each=card.querySelector('[data-bundle-each]');each.textContent=this.money(p.each)+' '+this.config.eachLabel;each.hidden=p.quantity===1;
   const save=card.querySelector('[data-bundle-save]');save.textContent=this.config.saveLabel+' '+this.money(p.saving);save.hidden=p.saving<=0;
   card.querySelector('[data-bundle-unavailable]').hidden=p.available;
  }
 }
}
customElements.define('oblivion-bundle',OblivionBundle);
})();
